import { createContext } from 'react';

export type VariantId = 'control' | 'user';
export interface UiVariant {
  id: VariantId;
  title: string;
  basename: string;                 // router base if you host under a subpath
  flags?: Record<string, boolean>;  // feature toggles if you need them
}

export const variants: Record<VariantId, UiVariant> = {
  control: { id: 'control', title: 'Control Panel', basename: '/control', flags: { canApprove: true } },
  user:    { id: 'user',    title: 'User Portal',   basename: '/user',    flags: { canApprove: false } },
};

export const VariantContext = createContext<UiVariant>(variants.user);
